import { gql } from '@apollo/client';

import {
  AddHyperbeamSessionDocument,
  type AddHyperbeamSessionMutation,
  type AddHyperbeamSessionMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation AddHyperbeamSession($input: AddHyperbeamSessionInput!) {
      addHyperbeamSession(input: $input) {
        sessionId
        embedUrl
        adminToken
      }
    }
  `;
}

export const ADD_HYPERBEAM_SESSION = AddHyperbeamSessionDocument;
export type {
  AddHyperbeamSessionMutation,
  AddHyperbeamSessionMutationVariables,
};
